import { render, staticRenderFns } from "./pad-heading.vue?vue&type=template&id=4f6abb82&scoped=true"
import script from "./pad-heading.vue?vue&type=script&lang=js"
export * from "./pad-heading.vue?vue&type=script&lang=js"
import style0 from "./pad-heading.vue?vue&type=style&index=0&id=4f6abb82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6abb82",
  null
  
)

export default component.exports